/**
 * GENERATOR TODO: move this to the webpack generator
 * Webpack global variable used for resolving paths for dynamic imports at runtime
 * This is useful for resolving the translation files within Soy2JS
 */
__webpack_public_path__ = Yext.baseUrl + __webpack_public_path__;

require('sass/brands/locations.wendys.com/intent/default.scss');
require('js/intent-script.js');